import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess404050ParamStatus: 'idle',
    startProcess404050ParamError: undefined as any,
    loadUserParamsProcess404050ParamStatus: 'idle',
    loadUserParamsProcess404050ParamError: undefined as any,

    process404050ParamList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess404050Param = createAsyncThunk('process404050ParamSlice/startProcess404050Param', async ({ process404050Param }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess404050Param/`,
        prepareData(process404050Param),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess404050ParamStatus } = getState().process404050ParamSlice
        return startProcess404050ParamStatus !== 'pending'
    }
})

export const loadUserParamsProcess404050Param = createAsyncThunk('process404050ParamSlice/loadUserParamsProcess404050Param', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess404050Param/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess404050ParamStatus } = getState().process404050ParamSlice
        return loadUserParamsProcess404050ParamStatus !== 'pending'
    }
})

const Process404050ParamSlice = createSlice({
    name: 'process404050ParamSlice',
    initialState,
    reducers: {
        resetstartProcess404050Param: (state) => {
            state.job = undefined
            state.startProcess404050ParamError = undefined
        },
        resetstartProcess404050ParamError: (state) => {
            state.startProcess404050ParamError = undefined
        },
        resetloadUserParamsProcess404050Param: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess404050ParamError = undefined
        },
        resetloadUserParamsProcess404050ParamError: (state) => {
            state.loadUserParamsProcess404050ParamError = undefined
        },
        removeFromProcess404050ParamListById: (state, action) => {
            state.process404050ParamList = state.process404050ParamList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess404050ParamListByIds: (state, action) => {
            state.process404050ParamList = state.process404050ParamList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process404050ParamList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess404050ParamStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process404050ParamList = []
            state.startProcess404050ParamStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess404050Param.pending, (state) => {
            state.startProcess404050ParamStatus = 'pending'
            state.startProcess404050ParamError = undefined
        })
        builder.addCase(startProcess404050Param.fulfilled, (state, action) => {
            state.startProcess404050ParamStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess404050Param.rejected, (state, action) => {
            state.startProcess404050ParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess404050ParamError = action.error.message
            } else {
                state.startProcess404050ParamError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess404050Param.pending, (state) => {
            state.loadUserParamsProcess404050ParamStatus = 'pending'
            state.loadUserParamsProcess404050ParamError = undefined
        })
        builder.addCase(loadUserParamsProcess404050Param.fulfilled, (state, action) => {
            state.loadUserParamsProcess404050ParamStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess404050Param.rejected, (state, action) => {
            state.loadUserParamsProcess404050ParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess404050ParamError = action.error.message
            } else {
                state.loadUserParamsProcess404050ParamError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess404050Param,
    resetstartProcess404050ParamError,
    resetloadUserParamsProcess404050Param,
    resetloadUserParamsProcess404050ParamError,
    removeFromProcess404050ParamListById,
    removeFromProcess404050ParamListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process404050ParamSlice.actions
export default Process404050ParamSlice.reducer
